import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchFilterTimesheet' })
export class SearchFilterPipeTimesheet implements PipeTransform {
  transform(filterCards: any, searchText?: any): any {
    if (!searchText) {
      return filterCards;
    }
    return filterCards.filter((filtercard: any) => {
      //hard coding each parameter
      // return (jobcard.country.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) || (jobcard.location.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) || (jobcard.transactionID.toLocaleLowerCase().includes(searchText..toLocaleLowerCase())) );

      //dynamic
      return Object.keys(filtercard?.oneRow).some((key) => {
        return String(filtercard?.oneRow[key]).toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
      });
    });
  }
}
